// Cuvva Handled Error Response (CHER) defines our internal error standard for expected errors that are safe to be marshalled to the user.
class Cher extends Error {
	constructor(code, reasons, meta) {
		if (!meta && !Array.isArray(reasons)) {
			meta = reasons;
			reasons = void 0;
		}

		for (const i in reasons) {
			if (!Cher.isCher(reasons[i]))
				reasons[i] = Cher.coerce(reasons[i]);
		}

		super(code);

		if (Error.captureStackTrace !== void 0)
			Error.captureStackTrace(this, this.constructor);

		this.code = code;
		this.reasons = reasons;
		this.meta = meta;

		defineNonSerializable(this, 'name', 'Cher');
		defineNonSerializable(this, 'message', this.code);
	}

	// handy evaluation
	static isCher(error) {
		return (error instanceof Cher);
	}

	// create new cher instance from some unknown object
	static coerce(error) {
		if (Cher.isCher(error))
			return error;

		let newError;

		if (error && typeof error.code === 'string') {
			// if code is a string, obj already conforms to Cher structure (e.g. cuvva-log CuvvaError)
			newError = new Cher(error.code, error.reasons, error.meta);
		} else if (error instanceof Error) {
			// if obj is an Error, pull out its useful details
			newError = new Cher('unknown', error.message ? { message: error.message } : void 0);
		} else {
			// worst case, just provide obj in the meta fields
			newError = new Cher('unknown', error ? { error } : void 0);
		}

		if (error instanceof Error)
			defineNonSerializable(newError, 'stack', error.stack);

		return newError;
	}

	// maps common cher codes to HTTP status code
	statusCode() {
		switch (this.code) {
			case 'bad_request':
				return 400;

			case 'unauthorized':
				return 401;

			case 'access_denied':
				return 403;

			case 'not_found':
			case 'route_not_found':
				return 404;

			case 'method_not_allowed':
				return 405;

			case 'no_longer_supported':
				return 410;

			case 'too_many_requests':
				return 429;

			case 'unknown':
			case 'traditional_error':
				return 500;

			default:
				return 400;
		}
	}
}

function defineNonSerializable(obj, property, value) {
	Object.defineProperty(obj, property, {
		value,
		writable: false,
		enumerable: false, // prevents json serialization
		configurable: true, // allows redefinition
	});
}

module.exports = Cher;
